<template>
  <div>
    <div class="d-flex my-5 row border mx-2">
      <div class="d-flex flex-column">
        <div class="mx-5">آپلود عکس</div>
        <br>
        <div class="align-self-start mx-5">انتخاب دسته بندی عکس:</div>
      </div>
      <select class="align-self-center form-control mb-3 mx-5" v-model="state">
        <option value="" selected>دسته بندی را انتخاب کنید</option>
        <option value="0">رندر</option>
        <option value="1">بازرسی</option>
        <option value="2">برداشت</option>
      </select>
      <input type="file" class="align-self-center form-control mx-5" ref="file" multiple="multiple" v-if="state!=''">
      <button type="button" class="align-self-center btn btn-primary my-4 btn-block mx-5" @click="submit" v-if="state!=''">ذخیره</button>
      </div>
      <div class="progress m-b-20" v-if="progress > 0 && progress < 100">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: progress + '%'}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
        </div>
      </div>

      <div class="accordion" id="accordionExample">
        <div class="card" v-for="(image, key, index) in images" :key="index">
          <div class="card-header bg-primary d-flex justify-content-center"  :id="'heading' + key">
            <button class="btn btn-link primary-font collapsed text-white btn-block" type="button" data-toggle="collapse" :data-target="'#collapse' + key" aria-expanded="false" :aria-controls="'collapse' + key">
             <h5>{{categories[key]}} </h5>
            </button>
          </div>
          <div :id="'collapse' + key" class="collapse" :aria-labelledby="'heading' + key" data-parent="#accordionExample">
            <div class="py-5">
              <div class="container">
                <div class="row">
                  <silent-box :gallery="image" class="">
                    <template v-slot:silentbox-item="{ silentboxItem }">
                        <img :src="silentboxItem.src" alt="project-image" width="350" height="350" class="bd-placeholder-img border"/>
                        <div class="card-body">
                          <div class="row py-1">
                            <button class="btn btn-outline-danger btn-block" @click="deleteImage(silentboxItem.id)">حذف</button>
                          </div>
                          <div class="row py-1" v-for="(category, catIndex) in categories" :key="catIndex">
                              <button v-if="catIndex != key" class="btn btn-outline-success btn-block"  @click="changeCategory(silentboxItem.id,catIndex)">
                                {{category}}
                              </button>
                          </div>
                        </div>
                    </template>
                </silent-box>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
  </div>
</template>

<script>

export default {
  name: 'Gallery',
  props: ['images'],
  data () {
    return {
      active: false,
      showImage: null,
      state: '',
      categories: ['رندر', 'بازرسی', 'برداشت'],
      progress: 0,
      count: 0
    }
  },
  watch: {
    progress: function (val) {
      if (val === 100) {
        this.$parent.startGallery()
        // eslint-disable-next-line no-undef
        swal(
          'تبریک!',
          'فایل ها با موفقیت آپلود شدند!',
          'success'
          , {
            button: 'باشه'
          })
      }
    }
  },
  created () {
    if (this.images == null) {
      this.$parent.startGallery()
    }
  },
  methods: {
    show (path) {
      this.active = !this.active
      this.showImage = path
    },
    submit () {
      if (this.$refs.file.files.length === 0) {
        // eslint-disable-next-line no-undef
        swal(
          'خطا!',
          'عکسی انتخاب نشده!',
          'warning'
          , {
            button: 'باشه'
          })
      }
      this.count = this.$refs.file.files.length
      for (var i = 0; i < this.count; i++) {
        const formData = new FormData()
        const file = this.$refs.file.files[i]
        formData.append('file', file)
        this.$send.submit('post', 'api/project/' + this.$route.params.id + '/upload/image/' + this.state, formData)
          .then(response => {
            this.progress += 100 / this.count
          })
      }
    },
    filterCategories (index) {
      return this.categories.filter(category => category !== this.categories[index])
    },
    changeCategory (imageId, categoryIndex) {
      this.$send.submit('get', 'api/project/gallery/change/status/' + imageId + '/' + categoryIndex)
        .then(response => {
          this.$parent.startGallery()
        })
    },
    deleteImage (imageId) {
      this.$send.submit('delete', '/api/project/gallery/delete/image/' + imageId)
        .then(response => {
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'عکس  با موفقیت حذف شدند!',
            'success'
            , {
              button: 'باشه'
            })
          this.$parent.startGallery()
        })
    }
  }
}
</script>
